
const getMessageError = (response) => {
    let message = "";
    if (response) {
        let { data, status } = response;

        switch (status) {
            case 400:
                // Bad Request
                message = data.message || data.error || "Solicitud incorrecta. Verifique los datos enviados.";
                break;

            case 401:
                // Unauthorized
                message = "No autorizado. Por favor, inicie sesión nuevamente.";
                break;

            case 403:
                // Forbidden
                message = "No tiene permisos para realizar esta acción.";
                break;

            case 404:
                // Not Found
                message = data.message || "Recurso no encontrado.";
                break;

            case 406:
                // Not Acceptable - Errores de validación
                if (data.errors && Array.isArray(data.errors)) {
                    message = "Error de validación:\n";
                    data.errors.forEach(msg => {
                        message += "• " + msg + "\n";
                    });
                } else {
                    message = data.error || data.message || "Error de validación de datos.";
                }
                break;

            case 409:
                // Conflict
                message = data.message || "Conflicto: El recurso ya existe o hay un conflicto de datos.";
                break;

            case 422:
                // Unprocessable Entity
                message = data.message || "Los datos enviados no pueden ser procesados.";
                break;

            case 500:
                // Internal Server Error

                // Detectar errores específicos de email
                if (data.message && data.message.includes("Mail server connection failed")) {
                    message = "Error de configuración de email: El responsable se creó correctamente, pero no se pudo enviar la notificación por email.";
                } else if (data.message && (data.message.includes("MailSendException") || data.message.includes("SMTP"))) {
                    message = "Error de email: El responsable se creó correctamente, pero hubo un problema al enviar la notificación.";
                } else if (data.message && data.message !== "Internal Server Error") {
                    // Si hay un mensaje específico del servidor, mostrarlo
                    message = `Error interno del servidor: ${data.message}`;
                } else if (data.error && typeof data.error === 'string') {
                    // Si hay detalles del error, mostrar una versión simplificada
                    const errorDetails = data.error.includes('Exception')
                        ? data.error.split(':')[0] // Solo el tipo de excepción
                        : data.error;
                    message = `Error interno del servidor: ${errorDetails}`;
                } else {
                    // Mensaje genérico
                    message = "Error interno del servidor. Por favor, contacte al administrador.";
                }
                break;

            case 502:
                // Bad Gateway
                message = "Error de conexión con el servidor. Intente nuevamente.";
                break;

            case 503:
                // Service Unavailable
                message = "Servicio no disponible temporalmente. Intente más tarde.";
                break;

            default:
                // Otros errores
                if (data.message) {
                    message = data.message;
                } else if (data.error) {
                    message = data.error;
                } else if (data.errors && Array.isArray(data.errors)) {
                    message = "Errores encontrados:\n";
                    data.errors.forEach(msg => {
                        message += "• " + msg + "\n";
                    });
                } else {
                    message = `Error ${status}: ${response.statusText || 'Error desconocido'}`;
                }
                break;
        }
    }

    return message;
}

export default {
    getMessageError
}